// Copyright (c) 2020 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Criteria, {getDefaultState as getCriteriaDefaultState} from './criteria';
import Part, {getDefaultState as getPartDefaultState} from '@deere/cps-it.warranty-model-factory/lib/part';
import PartsCoverageSearchStatusChangeModal, {getDefaultState as getPartsCoverageSearchStatusChangeModalDefaultState} from './parts-coverage-search-status-change-modal';
import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import Report, {getDefaultState as getReportDefaultState} from './report';
import Warranties, {getDefaultState as getWarrantiesDefaultState} from './warranties';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    criteria: Criteria,
    isAmountOfUseModalOpen: t.Boolean,
    part: Part,
    partsCoverageSearchStatusChangeModal: PartsCoverageSearchStatusChangeModal,
    pin: t.String,
    product: Product,
    report: Report,
    showNoResultsFound: t.Boolean,
    warranties: Warranties
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        criteria: getCriteriaDefaultState(),
        isAmountOfUseModalOpen: false,
        part: getPartDefaultState(),
        partsCoverageSearchStatusChangeModal: getPartsCoverageSearchStatusChangeModalDefaultState(),
        pin: '',
        product: getProductDefaultState(),
        report: getReportDefaultState(),
        showNoResultsFound: false,
        warranties: getWarrantiesDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/state/index.js